import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { getWarehouses, loaderState } from '../../../../actions';
import { initilizeDataTable, destroyDataTable, warehousesData, goto } from '../../../../helpers';
import ViewSalesOrderComp from '../../../../components/sales/order/view';

class ViewSalesOrder extends Component {
	componentDidMount() {
		const { warehouses } = this.props;
		if (warehouses.length === 0) {
			this.props.loaderState(true);
			this.props.getWarehouses();
		}
		initilizeDataTable('view-sales-order-table');
	}

	componentDidUpdate() {
		initilizeDataTable('view-sales-order-table');
	}

	render() {
		destroyDataTable('view-sales-order-table');

		const { warehouses } = this.props;
		return <ViewSalesOrderComp goto={path => goto(path)} warehouses={warehousesData(warehouses)} />;
	}
}

const mapStateToProps = state => {
	return {
		warehouses: state.system.warehouses.allWarehouses,
	};
};

export default connect(mapStateToProps, { loaderState, getWarehouses })(ViewSalesOrder);
